import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateLocalidadDto, Localidad } from './types/types';

export class LocalidadesService {
  static async create(dto: CreateLocalidadDto): Promise<Localidad> {
    const response: AxiosResponse<Localidad> = await AxiosService.post('/localidades', dto);
    return response.data;
  }
  static async update(id: string, dto: CreateLocalidadDto): Promise<Localidad> {
    const response: AxiosResponse<Localidad> = await AxiosService.put(`/localidades/${id}`, dto);
    return response.data;
  }

  static async findAll(): Promise<Localidad[]> {
    const response: AxiosResponse<Localidad[]> = await AxiosService.get('/localidades');
    return response.data;
  }

  static async findOne(id: string): Promise<Localidad> {
    const response: AxiosResponse<Localidad> = await AxiosService.get(`/localidades/${id}`);
    return response.data;
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/localidades/${id}`);
  }
}